export default function (version) {
  delete version.recorded_at;
  delete version.final_recording;
  delete version.upload_token;
  delete version.upload_complete;
  delete version.share_link_url;

  return version;
}
